<template>
  <div class="home">
    <section class="homeHead">
      <Slideshow sliderheight="80vh" slidespeed="800" timeslide="6000" rightnav_class="fas fa-angle-right fa-4x"
        leftnav_class="fas fa-angle-left fa-4x">
        <div>
          <img src="@/assets/images/018.jpg" alt="Gite d'en lebé" style="object-position: 0 80%" />
        </div>
        <div>
          <img src="@/assets/images/040.jpg" alt="Gite d'en lebé" />
        </div>
        <div>
          <img src="@/assets/images/037.jpg" alt="Gite d'en lebé" />
        </div>
        <div>
          <img src="@/assets/images/041.jpg" alt="Gite d'en lebé" />
        </div>
      </Slideshow>

      <GreenBarContact class="absoGreenBar"></GreenBarContact>
    </section>

    <section class="welcomeSection">
      <img alt="gite d'en lebe logo" class="logo" src="@/assets/logo.png" />

      <h2 class="titlePage">
        <strong>_</strong>
        Bienvenue chez nous
        <strong>_</strong>
      </h2>
      <div class="fioriture"></div>

      <div class="wsContent">
        <article>
          <p>
            Bienvenue au Gîte d’en Lebé, votre gîte de charme dans le Gers pour des vacances inoubliables en famille ou entre amis (une capacité jusqu'à 15 personnes)
            <br /> <br>
            Nichée dans un écrin calme et ombragé au cœur du Gers, cette location de gîte offre piscine privée chauffée et tout le confort moderne pour vos vacances. Idéal pour un week-end, une semaine ou un long séjour en famille (avec espace enfants sécurisé) ou entre amis.
            <br />
          </p>
          <img src="@/assets/images/accueil-piscine.jpg" alt="cuisine du gite en lébé" />
        </article>

        <article>
          <img src="@/assets/images/accueil-salle amanger.jpg" alt="Vue sur la piscine" />
          <p>
            Profitez des activités variées du Gers : balades, marchés, patrimoine et gastronomie, après une journée à la piscine ou dans les espaces ombragés extérieurs. Le gîte dispose de 4 chambres cosy, cuisine équipée, salon spacieux et terrasse ombragée pour repas conviviaux.
            <br /> <br>
            Réservez dès maintenant votre gîte dans le Gers  pour un séjour au calme, avec piscine, activités et tout le confort familial.
            <br>
            <router-link to="/contact" class="greenBtn">Réservez</router-link>
          </p>
        </article>
      </div>
    </section>

    <section class="avion home">
      <img src="@/assets/images/background/027.jpg" alt="avion coucou au décolage" />
      <div>
        <h3 class="title-white">
          Vous pouvez maintenant rejoindre
          <br />le Gîte d'en Lébé par les airs !
        </h3>
        <!-- <p class="title-white">
          <span class="title-white">L’accès par les airs est aussi possible. Une piste privée est réservée pour
            l’aviation légère.</span>
          <br />
          <span class="title-white">Si cela vous tente, veuillez nous contacter pour toutes les formalités
            administratives et de
            sécurité.</span>
        </p> -->
        <router-link to="/aerodrome" class="greenBtn">Voir plus d'infos</router-link>
      </div>
    </section>

    <!-- <section class="roomsSection">
      <h3>
        <strong>_</strong>Nos services
        <strong>_</strong>
      </h3>
      <p>
        L’Agriculture Bio est une passion, l’accueil en est une autre.
        <br />Rencontres, partage, convivialité, repos, amitié …. Autant de mots qui représentent notre motivation à
        vous
        accueillir En Lébé !
        <br />Le temps d’un week-end ou pour plusieurs jours, différentes formules s’offrent à vous :
      </p>

      <div>
        <article class="roomsSectionItem">
          <img src="@/assets/images/legite.jpg" alt="le gite" />
          <router-link to="/nos-hebergements/le-gite">
            <div class="roomsSectionFilter">
              <div class="hebHover">
                <h3>Le gîte</h3>
                <p>
                  Gîte de séjour de caractère, de grande capacité.
                  Parfaitement équipé et de grand confort.
                  Pour 6 ou 15 personnes
                </p>
              </div>
            </div>
          </router-link>
        </article>

        <article class="roomsSectionItem">
          <img src="@/assets/images/003.jpg" alt="Les chambres d'hotes" />
          <router-link to="/nos-hebergements/chambres-d-hotes">
            <div class="roomsSectionFilter">
              <div class="hebHover">
                <h3>Les chambres d'hôtes</h3>
                <p>3 chambres très confortables offrant de belles prestations.</p>
              </div>
            </div>
          </router-link>
        </article>
        <article class="roomsSectionItem">
          <img src="@/assets/images/lescalestudio.jpg" alt="Le studio" />
          <router-link to="/nos-hebergements/studio">
            <div class="roomsSectionFilter">
              <div class="hebHover">
                <h3>L'Escale</h3>
                <p>Petit gîte pour 2 personnes vous offre tout le confort et le calme dont vous rêvez</p>
              </div>
            </div>
          </router-link>
        </article>
        <article class="roomsSectionItem">
          <img src="@/assets/images/epicerie/camionnette.jpg" alt="l'épicerie de nanou" />
          <router-link to="/epicerie">
            <div class="roomsSectionFilter">
              <div class="hebHover">
                <h3>L'épicerie</h3>
                <p>La camionette de Nanou, épicerie itinérante et traditionnelle</p>
              </div>
            </div>
          </router-link>
        </article>
      </div>
    </section> -->

    <div class="fioriture" v-if="$store.state.gbbuArticles"></div>

    <section class="actuSection" v-if="$store.state.gbbuArticles">
      <h3>
        <strong>_</strong>
        <router-link to="actualites">Nos actualités</router-link>
        <strong>_</strong>
      </h3>
      <p>Blog</p>

      <div class="scrollX">
        <div>
          <article v-for="item in $store.state.gbbuArticles.slice(0, 3)" :key="item.idA">
            <router-link :to="`actualites/${item.idA}`">
              <img :src="buildImgUrl(item.idA, item.pictureThumbA)" alt="actualité" style="object-position: top" />
              <p>
                <span>{{ returnDate(item.datePublicationA) }}</span>
                <br />
                <strong v-html="splitExtrait(item.titleA, item.titleSubA)" style="font-weight: normal"></strong>
              </p>
            </router-link>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Slideshow from "@/components/Slideshow.vue";
import GreenBarContact from "@/components/GreenBarContact.vue";

export default {
  name: "Home",
  components: {
    Slideshow,
    GreenBarContact,
  },

  data() {
    return {
      urlImage:
        "https://cdn-gbbu02.graphibox.eu/pub/" +
        this.$store.state.globalData.siteId +
        "/medias/articles/",
    };
  },
  methods: {
    buildImgUrl(id, img) {
      return this.urlImage + id + "/" + img;
    },
    returnDate(date) {
      let a = new Date(date);
      const month = a.toLocaleString("default", { month: "long" });
      return a.getDay() + " " + month + " " + a.getFullYear();
    },
    splitExtrait(title, description) {
      let val = title + "<br/>" + description;
      if (val.length > 140) {
        val = val.substring(0, 140) + "...";
      }
      return val;
    },
  },
};
</script>
<style>
.title-white {
  color: #FFF;
}

.homeHead {
  width: 100%;
  position: relative;
}

.homeHead .slideBtn {
  color: #fff;
}

.welcomeSection {
  text-align: center;
}

.welcomeSection .logo {
  width: 70px;
  margin: 2rem;
}

.welcomeSection h2 {
  color: #333;
  margin: 0;
  font-size: 4.5rem;
  word-spacing: 2px;
}

.avion span {
  color: #fff !important;
}

.avion.home img {
  height: 700px;
  object-fit: cover;
}

.greenBtn {
    background-color: var(--dark-color);
    color: white;
    font-weight: 600;
}

.absoGreenBar.barBottom .navImg {
  background: rgba(168, 190, 80, 0.7);
}

.wsContent {
  display: flex;
  padding: 0 19%;
}

.wsContent article {
  width: 48%;
  margin: 1%;
  text-align: left;
}

.wsContent article img {
  height: 700px;
  width: 100%;
  object-fit: cover;
  display: flex;
}

.wsContent p {
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 500;
}

.roomsSection {
  text-align: center;
}

.roomsSection>h3 {
  /* color: var(--dark-color); */
  font-size: 3rem;
  /* text-transform: uppercase; */
  margin: 4rem 0 1rem;
  font-weight: 100;
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
  font-variation-settings: "wght" 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.roomsSection h3 strong {
  font-size: 3rem;
  line-height: 0;
  padding-bottom: 1.2rem;
  margin: 0 12px;
}

.roomsSection p {
  letter-spacing: 0.5px;
  margin-bottom: 3rem;
}

.roomsSection>div {
  display: flex;
  padding: 0 20%;
  flex-wrap: wrap;
}

.roomsSectionItem {
  position: relative;
  width: 48%;
  height: 400px;
  margin: 1%;
  cursor: pointer;
}

.roomsSectionItem>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.roomsSectionFilter {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.hebHover {
  position: absolute;
  top: 30px;
  left: 30px;
  right: 30px;
  bottom: 30px;
  border: 1px white solid;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hebHover h3 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-weight: 100;
  margin: 0;
  transition: all 0.3s ease;
  width: 100%;
  font-size: 3rem;
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
  font-variation-settings: "wght" 1000;
}

.hebHover p {
  color: white;
  margin: 0 0.5rem;
  opacity: 0;
  transition: all 0.5s ease;
  font-size: 1rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  transition: all 0.3s ease;
}

.roomsSectionItem:hover h3 {
  top: 12%;
  transition: all 0.7s ease;
}

.roomsSectionItem:hover .roomsSectionFilter {
  background: rgba(0, 0, 0, 0.5);
  transition: all 1s ease;
}

.roomsSectionItem:hover p {
  top: 88%;
  opacity: 1;
  transition: all 0.7s ease;
}

@media all and (max-width: 1500px) {
  .roomsSection>div {
    padding: 0 10%;
  }
}

@media all and (max-width: 1400px) {
  .wsContent {
    padding: 0 12%;
  }

  .welcomeSection h2 {
    margin-bottom: 4rem;
  }
}

@media all and (max-width: 1200px) {
  .wsContent {
    padding: 0 10%;
  }

  .welcomeSection h2 {
    margin-bottom: 2rem;
  }
}

@media all and (max-width: 1100px) {
  .wsContent {
    padding: 0 5%;
  }

  .roomsSection>div {
    padding: 0 5%;
  }
}

@media all and (max-width: 968px) {
  .wsContent {
    flex-direction: column;
    display: flex;
    flex-direction: column-reverse;
  }

  .wsContent article {
    width: 98%;
  }

  .wsContent article img {
    height: 350px;
  }

  .wsContent:last-child {
    display: flex;
    flex-direction: column;
  }

  .roomsSection>div {
    padding: 0 1%;
  }

  .welcomeSection h2 {
    margin-bottom: 0;
    font-size: 2.5rem;
  }
}

@media all and (max-width: 768px) {
  .homeHead .slideBtn {
    display: none;
  }

  .homeHead>img {
    height: 80vh;
    object-position: 10% 90%;
  }

  .navImg {
    align-items: flex-end;
  }

  .navImg p {
    font-size: 0.8rem;
  }

  .navImg strong {
    font-weight: bold;
    font-size: 1rem;
  }

  .wsContent {
    padding: 0 1%;
  }

  .roomsSectionItem {
    position: relative;
    width: 98%;
  }

  .hebHover {
    top: 10px;
    left: 10px;
    bottom: 10px;
    right: 10px;
  }

  .roomsSectionItem h3 {
    top: 12%;
  }

  .hebHover p {
    opacity: 1;
    top: 88%;
  }

  .scrollX {
    overflow-x: scroll;
  }
}

@media all and (max-width: 550px) {
  .navImg {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .navImg a {
    margin: 1% 0;
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
    text-align: left;
  }

  .navImg i {
    margin: 0 2rem;
  }

  .navImg img {
    margin: 0 1.5rem;
  }

  .navImg p {
    font-size: 1rem;
  }

  .navImg strong {
    font-weight: bold;
    font-size: 1.2rem;
  }
}

@media all and (max-width: 400px) {
  .roomsSection h3 {
    font-size: 10vw;
  }

  .navImg a {
    margin: 1% 0;
  }

  .navImg strong {
    font-size: 1rem;
  }

  .navImg i {
    margin: 0 2%;
  }

  .navImg img {
    margin: 0 1.5%;
  }
}
</style>
